<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <ul class="thumbnails">
          <li>
            <a class="thumbnail fancybox" href="#" :title="data.name"
              ><img :src="data.image[0]" :title="data.name" :alt="data.name"
            /></a>
          </li>
          <div id="product-thumbnail" class="owl-carousel">
            <div class="item" v-for="(image, index) in data.image" :key="index">
              <li class="image-additional">
                <a
                  class="thumbnail fancybox"
                  rel="gallery1"
                  :href="data.image[index]"
                  :title="data.name"
                  target="_blank"
                >
                  <img :src="image" :title="data.name" :alt="data.name" />
                </a>
              </li>
            </div>
          </div>
        </ul>
      </div>
      <div class="col-sm-6">
        <h1 class="productpage-title">{{ data.name }}</h1>
        <ul class="list-unstyled productinfo-details-top">
          <li>
            <h2 class="productpage-price">${{ data.price | numeral(0, 0) }}</h2>
          </li>
        </ul>
        <hr />
        <ul class="list-unstyled product_info">
          <li>
            <label><b>Brand: </b></label>
            <span>{{ data.brand }}</span>
          </li>
          <li>
            <label><b>Category: </b></label>
            <span>{{ data.category }}</span>
          </li>
          <li>
            <label><b>Availability: </b></label>
            <span>{{ data.availability ? "In Stock" : "Out of Stock" }}</span>
          </li>
        </ul>
        <hr />
        <p class="product-desc">
          {{ data.desc }}
        </p>
        <div id="product">
          <div class="form-group">
            <label class="control-label qty-label" for="input-quantity"
              >Qty</label
            >
            <input
              type="text"
              name="quantity"
              size="2"
              id="input-quantity"
              class="form-control productpage-qty"
              v-model="productQuantity"
            />
            <input type="hidden" name="product_id" value="" />
            <div class="btn-group">
              <button
                type="button"
                id="button-cart"
                data-loading-text="Loading..."
                class="btn btn-primary btn-lg btn-block addtocart"
                :class="{ disabled: isProductBasket }"
                @click="addCart()"
              >
                Add to Cart
              </button>
              <button
                v-if="isWsihList == false"
                type="button"
                id="button-cart"
                data-loading-text="Loading..."
                class="btn btn-primary btn-lg btn-block addtocart"
                @click="addWishlist()"
              >
                Add to Wsih List
              </button>
              <button
                v-if="isWsihList"
                type="button"
                id="button-cart"
                data-loading-text="Loading..."
                class="btn btn-primary btn-lg btn-block addtocart"
                @click="removeWishlist()"
              >
                Remove from Wsih List
              </button>
              <!--<button
                type="button"
                id="button-cart"
                data-loading-text="Loading..."
                class="btn btn-primary btn-lg btn-block addtocart"
                @click="removeCart()"
                v-else
              >
                Remove to Cart
              </button>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="productinfo-tab">
      <ul class="nav nav-tabs">
        <li class="active">
          <a href="#tab-description" data-toggle="tab">Description</a>
        </li>
        <li><a href="#tab-review" data-toggle="tab">Reviews (1)</a></li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="tab-description">
          <div class="cpt_product_description ">
            <div>
              <p>{{ data.desc }}</p>
            </div>
          </div>
          <!-- cpt_container_end -->
        </div>
        <div class="tab-pane" id="tab-review">
          <form class="form-horizontal">
            <div id="review"></div>
            <h2>Write a review</h2>
            <div class="form-group required">
              <div class="col-sm-12">
                <label class="control-label" for="input-name">Your Name</label>
                <input
                  type="text"
                  name="name"
                  value=""
                  id="input-name"
                  class="form-control"
                />
              </div>
            </div>
            <div class="form-group required">
              <div class="col-sm-12">
                <label class="control-label" for="input-review"
                  >Your Review</label
                >
                <textarea
                  name="text"
                  rows="5"
                  id="input-review"
                  class="form-control"
                ></textarea>
                <div class="help-block">
                  <span class="text-danger">Note:</span> HTML is not translated!
                </div>
              </div>
            </div>
            <div class="form-group required">
              <div class="col-sm-12">
                <label class="control-label">Rating</label>
                &nbsp;&nbsp;&nbsp; Bad&nbsp;
                <input type="radio" name="rating" value="1" />
                &nbsp;
                <input type="radio" name="rating" value="2" />
                &nbsp;
                <input type="radio" name="rating" value="3" />
                &nbsp;
                <input type="radio" name="rating" value="4" />
                &nbsp;
                <input type="radio" name="rating" value="5" />
                &nbsp;Good
              </div>
            </div>
            <div class="buttons clearfix">
              <div class="pull-right">
                <button
                  type="button"
                  id="button-review"
                  data-loading-text="Loading..."
                  class="btn btn-primary"
                >
                  Continue
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <button
                    type="button"
                    class="close"
                    @click="showModal = false"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div
                  class="modal-body"
                  style="text-align:center;font-size:17px;"
                >
                  <div class="alert alert-success" role="alert">
                    Product successfully added to cart
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import setCart from '../../mixins/setCart';

export default {
  name: "ProductDetails",
  mixins: [setCart],
  props: {
    data: {
      type: Object
    }
  },
  data() {
    return {
      basketData: JSON.parse(localStorage.getItem("basket")) || [],
      wishlist: JSON.parse(localStorage.getItem("wishlist")) || [],
      isProductBasket: false,
      isWsihList: false,
      productQuantity: 1,
      showModal: false
    };
  },
  methods: {
    addCart() {
      this.data.quantity = parseInt(this.productQuantity);
      this.basketData.push(this.data);
      localStorage.setItem("basket", JSON.stringify(this.basketData));
      this.isProductBasket = true;
      this.showModal = true;

      Segmentify("basket:add", {
        productId: this.data.id,
        quantity: parseInt(this.productQuantity),
        price: parseInt(this.data.price)
      });

      /*dengage("sendDeviceEvent", "user_events", {
        event_type: "add_basket",
        product_id: this.data.id,
        quantity: parseInt(this.productQuantity)
      });*/
      /*dataLayer.push({
        event: 'dengage_event',
        dengage_table_name: 'user_events',
        dengage_event_data: {
          event_type: "add_basket",
          product_id: this.data.id,
          quantity: parseInt(this.productQuantity)
        }
      });*/
    

      dengage('ec:addToCart', {
        product_id: this.data.id,
        product_variant_id: '1',
        quantity: parseInt(this.productQuantity),
        unit_price: this.data.price,
        discounted_price: this.data.price,
        // ... shopping_cart_events tablosundaki ekstra kolonlar da olabilir
        cartItems: this.basketData.map(b => {
          return {
              product_id: b.id,
              product_variant_id: '1',
              quantity: b.quantity,
              unit_price: b.price,
              discounted_price: b.price,
              // ... shopping_cart_events_detail tablosundaki ekstra kolonlar da olabilir
          };
        }),
      });

      this.setCartForDengage();
      //collector.addToBasket(this.data.id, 1, parseInt(this.productQuantity), parseInt(this.data.price), parseInt(this.data.price), 'USD', '', localStorage.getItem('basket_id'), localStorage.getItem('contact_key'));
    },
    addWishlist() {
      this.isWsihList = true;
      this.wishlist.push({product_id: this.data.id});
      localStorage.setItem("wishlist", JSON.stringify(this.wishlist));

      dengage('ec:addToWishlist', {
        product_id: this.data.id,
        items: this.wishlist,
      });
    },
    removeWishlist() {
      this.isWsihList = false;
      const productId = this.data.id;
      const index = this.wishlist.findIndex(function(o) {
        return o.product_id === productId;
      });
      if (index !== -1) {
        this.wishlist.splice(index, 1);
      }
      console.log(this.wishlist)
      localStorage.setItem("wishlist", JSON.stringify(this.wishlist));
      dengage('ec:removeFromWishlist', {
        product_id: this.data.id,
        // ... wishlist_events tablosundaki ekstra kolonlar da olabilir
        items: this.wishlist,
      });
    },
    removeCart() {
      const productId = this.data.id;
      const index = this.basketData.findIndex(function(o) {
        return o.id === productId;
      });
      if (index !== -1) {
        this.basketData.splice(index, 1);
      }
      localStorage.setItem("basket", JSON.stringify(this.basketData));
      this.isProductBasket = false;

      Segmentify("basket:remove", {
        productId: this.data.id,
        quantity: parseInt(this.productQuantity),
        price: parseInt(this.data.price)
      });
      /*dengage("sendDeviceEvent", "user_events", {
        event_type: "remove_basket",
        product_id: this.data.id,
        quantity: parseInt(this.productQuantity)
      });*/
      /*dataLayer.push({
        event: 'dengage_event',
        dengage_table_name: 'user_events',
        dengage_event_data: {
          event_type: "remove_basket",
          product_id: this.data.id,
          quantity: parseInt(this.productQuantity)
        }
      });*/
      dengage('ec:removeFromCart', {
        product_id: this.data.id,
        product_variant_id: '1',
        quantity: parseInt(this.productQuantity),
        unit_price: this.data.price,
        discounted_price: this.data.price,
        // ... shopping_cart_events tablosundaki ekstra kolonlar da olabilir
        cartItems: this.basketData.map(b => {
          return {
              product_id: b.id,
              product_variant_id: '1',
              quantity: b.quantity,
              unit_price: b.price,
              discounted_price: b.price,
              // ... shopping_cart_events_detail tablosundaki ekstra kolonlar da olabilir
          };
        }),
      });

      this.setCartForDengage();
      //collector.removeFromBasket(this.data.id, 1, parseInt(this.productQuantity), localStorage.getItem('basket_id'), localStorage.getItem('contact_key'));
    }
  },
  created() {
    if (this.basketData.filter(p => p.id == this.data.id).length > 0) {
      this.isProductBasket = true;
    }
    if (this.wishlist.filter(p => p.product_id == this.data.id).length > 0) {
      this.isWsihList = true;
    }
    
  },
  mounted() {
    $("#product-thumbnail").owlCarousel({
      navigation: true,
      pagination: false,
      itemsDesktop: [430, 4],
      itemsDesktopSmall: [430, 3],
      itemsTablet: [768, 4],
      itemsTabletSmall: false,
      itemsMobile: [479, 3]
    });
    var a = {
        pageName: "product-page",
        pageType: "pdp",
        category: this.data.category,
        page_title: this.data.category,
        dn_product_id: this.data.id,
      }
      dataLayer.push(a);
  },
  watch: {
    showModal: {
      handler(value) {
        if (value) {
          setTimeout(f => {
            this.showModal = false;
          }, 1500);
        }
      }
    }
  }
};
</script>

<style scoped>
.product-desc {
  text-align: justify;
}
.owl-carousel >>> .owl-item {
  max-width: 92px;
}
.thumbnails {
  overflow: hidden;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductDetails.vue